import { navigate } from "gatsby"
import React, { Component } from "react"
import Store from "../store"
import LocalsMenu from "./localsMenu.json"
import i18n from "../utils/i18n"
import constants from "../constants"
import colourPigment from "../../static/colour-pigment.jpg"
import sciencePigment from "../../static/science-pigment.jpg"
// import { gsap } from "gsap"

class NextStoryButton extends Component {
  constructor(props) {
    super(props)
    this.parent = React.createRef()
    this.state = {
      story: ``
    }
  }
  componentDidMount() {
    Store.on(constants.UPDATE_STORY, this.onStoryUpdate)
  }
  componentWillUnmount() {
    Store.off(constants.UPDATE_STORY, this.onStoryUpdate)
  }
  onStoryUpdate = () => {
    this.setState({ story: Store.story === constants.COLOUR ? constants.SCIENCE : constants.COLOUR })
  }
  onTrigger = () => {
    if (Store.story === constants.COLOUR) navigate(`/${this.props.lang}/story/${constants.SCIENCE.toLowerCase()}`)
    else navigate(`/${this.props.lang}/story/${constants.COLOUR.toLowerCase()}`)
  }
  render() {
    const imgSrc = Store.story === constants.COLOUR ? sciencePigment : colourPigment
    return (
      <button onClick={this.onTrigger} style={{outline: 0}} ref={this.parent} className={`h-12 lg:h-16 ${constants.attribution}`}>
        <div className={`relative w-full h-full`}>
          <div className={`relative lg:-top-0.5 w-full h-full z-10`}>
            <div className={`w-full h-full px-6 text-white inline-flex items-center justify-center`}>
              {i18n(LocalsMenu, `title-next-up`, this.props.lang)}: {i18n(LocalsMenu, `title-${this.state.story.toLowerCase()}`, this.props.lang)}
            </div>
          </div>
          <img
            className={`inline-block absolute w-full h-full top-0 left-0 rounded-full`}
            src={imgSrc}
            alt={i18n(LocalsMenu, `title-next-up`, this.props.lang)}
          />
        </div>
      </button>
    )
  }
}

export default NextStoryButton